import React, { useState, useRef } from 'react';
import pdficon from "../../../../Common/FilesRelevent/pdf.png";
import CustomReactQuillDescription from '../../../../Common/CustomeLabel/ReactQuill/CustomReactQuillDescription';
import CustomeMilestone from '../../../../Common/CustomeLabel/CustomeMilestone';
import DownloadwithDisplayProper from '../../../../Common/FilesRelevent/DownloadwithDisplayProper';
import { useNavigate } from 'react-router-dom';

export default function AllTabPackage({ otsdetails }) {
    const navigate = useNavigate();
    const laung = localStorage.getItem("laung");
    const [lan, setLan] = useState(laung ?? "en");
    const [activeTab, setActiveTab] = useState('service-detail');
    const serviceDetailRef = useRef(null);
    const workSampleRef = useRef(null);

    const handleTabClick = (sectionRef, tabName) => {
        if (sectionRef.current) {
            sectionRef.current.scrollIntoView({ behavior: 'smooth', block: 'start' });
            setActiveTab(tabName);
        }
    };

    const handleImageError = (e) => {
        e.target.src = pdficon;
    };
    const movetodetails11 = (item) => {
        navigate(`/${lan}/worksample/${item?.id}`);
    }
    return (
        <div className="tab-package">
            <ul className="nav nav-tabs">
                <li className="nav-item">
                    <a
                        className={`nav-link ${activeTab === 'service-detail' ? 'active' : ''}`}
                        onClick={() => handleTabClick(serviceDetailRef, 'service-detail')}
                    >
                        Service Details
                    </a>
                </li>
                <li className="nav-item">
                    <a
                        className={`nav-link ${activeTab === 'work-sample' ? 'active' : ''}`}
                        onClick={() => handleTabClick(workSampleRef, 'work-sample')}
                    >
                        Work Samples
                    </a>
                </li>
                {/* <li className="nav-item">
                    <a
                        className={`nav-link ${activeTab === 'reviews' ? 'active' : ''}`}
                        onClick={() => handleTabClick(reviewsRef, 'reviews')}
                    >
                        Reviews
                    </a>
                </li> */}
            </ul>
            <div className="tab-content">
                <div className={`tab-pane ${activeTab === 'service-detail' ? 'active' : ''}`} ref={serviceDetailRef}>
                    <div className="requirementsec">
                        <h5>Requirements</h5>
                        <CustomReactQuillDescription value={otsdetails?.requirements} />
                    </div>

                    <div className="requirementsec">
                        <CustomeMilestone milestones={otsdetails?.milestones} />
                    </div>
                    <div className="requirementsec">
                        <h5>Additional notes</h5>
                        <CustomReactQuillDescription value={otsdetails?.terms} />
                    </div>
                </div>

                <div className={`tab-pane ${activeTab === 'work-sample' ? 'active' : ''}`} ref={workSampleRef}>
                    <div className="requirementsec">
                        {Array.isArray(otsdetails?.work_sample) && otsdetails?.work_sample?.length > 0 ? (
                            <>
                                <h5>Work samples</h5>
                                <div className="row row-pack">
                                    {otsdetails?.work_sample?.map((item, index) => (
                                        <div className="col-md-4" key={index}>
                                            {item.files.length != 0 && <DownloadwithDisplayProper item={item?.files[0]} />}
                                            <div className="row-img">
                                                <h4>{item?.title}</h4>
                                                <h6>Project link: <a>{item?.url}</a></h6>
                                            </div>
                                            <button className='buttons border-button' onClick={() => movetodetails11(item)}>
                                                View in Details
                                            </button>
                                        </div>
                                    ))}
                                </div>
                            </>
                        ) : (
                            <h5>Work sample list is empty.</h5>
                        )}
                    </div>
                </div>

                {/* <div className={`tab-pane ${activeTab === 'reviews' ? 'active' : ''}`} ref={reviewsRef}>
                    <div className="rating-sec">
                        <h2>
                            Rating and reviews
                            <span>
                                <i className="fa-solid fa-star"></i> 4.5
                            </span>
                        </h2>
                        <div className="rating-detail">
                            <p>
                                Turpis suspendisse elementum tincidunt ac viverra in
                                scelerisque. Ipsum porta in vulputate fringilla urna.
                                Fermentum etiam sed id iaculis leo. Ultricies tempus sit
                                proin ultrices habitant odio metus
                            </p>
                            <h5>Kianna Stanton</h5>
                        </div>
                    </div>
                </div> */}
            </div>
        </div>
    );
}
